'use client';

export default function HeadSchema() {
	const casinoSchema = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		'@id': 'https://www.otherworld.xyz/',
		name: 'Otherworld',
		alternateName: 'Otherworld - The Real Estate Crypto Casino',
		url: 'https://www.otherworld.xyz/',
		logo: 'https://www.otherworld.xyz/favicon/favicon-96x96.png',
		description:
			'Hybrid platform combining cryptocurrency online gambling with blockchain-based fantasy real estate casino.',
		sameAs: [
			'https://x.com/otherworldxyz',
			'https://t.me/otherworldxyz',
			'https://www.youtube.com/@otherworldxyz',
		],
		contactPoint: [
			{
				'@type': 'ContactPoint',
				contactType: 'Customer Support',
				email: 'support@otherworld.xyz',
				availableLanguage: ['English'],
			},
			{
				'@type': 'ContactPoint',
				contactType: 'Live Support',
				availableLanguage: ['English'],
			},
		],
		areaServed: ['Global'],
		keywords: 'crypto casino, bitcoin casino, online casino',
		currenciesAccepted:
			'ETH, BTC, EVERY, LTC, USDT, USDC, TRX, MATIC, XRP, SOL, DOGE, BNB, SHIB, BONK, WIF',
		paymentAccepted: 'Cryptocurrency',
		knowsAbout: ['Cryptocurrency', 'Online Casino', 'Online Gambling'],
		additionalProperty: [
			{
				'@type': 'PropertyValue',
				name: 'Gaming License',
				value:
					'Otherworld.xyz is authorized and regulated by the Government of Curaçao and operates under a Certificate of Operation from the Curacao Gaming Board',
			},
			{
				'@type': 'PropertyValue',
				name: 'Native Token',
				value: 'EVERY',
			},
		],
		makesOffer: [
			{
				'@type': 'Offer',
				name: 'Crypto Slots',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/slots',
			},
			{
				'@type': 'Offer',
				name: 'Crypto Classic Slots',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/classics',
			},
			{
				'@type': 'Offer',
				name: 'Casino Crypto Table Games',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/table-games',
			},
			{
				'@type': 'Offer',
				name: 'Crypto Crash Games',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/crash',
			},
			{
				'@type': 'Offer',
				name: 'Crypto Live Casino',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/live-casino',
			},
			{
				'@type': 'Offer',
				name: 'Crypto Roulette',
				category: 'Gambling',
				url: 'https://www.otherworld.xyz/casino/category/roulette',
			},
			{
				'@type': 'Offer',
				name: 'VIP Rewards',
				description:
					'Wager, win, and earn rewards as you unlock properties and build your real estate empire. Level up and make your way from real estate owner to benefactor with every bet you place.',
				category: 'Rewards',
				url: 'https://www.otherworld.xyz/vip/rewards',
			},
			{
				'@type': 'Offer',
				name: 'Deposit Bonus',
				category: 'Rewards',
				url: 'https://www.otherworld.xyz/rewards',
			},
		],
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(casinoSchema),
			}}
		/>
	);
}
